import { useState } from "react"
import { useDebouncedProperty } from "../../../../mp-core/hooks"

export const useSearchDropdownManage = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [searchInput, setSearchInput] = useState<string>("")
  const [debouncedSearchInput] = useDebouncedProperty(searchInput)
  const [isNarrowSearch, setIsNarrowSearch] = useState<boolean>(false)

  const loadingSetter = (value: boolean) => {
    setLoading(value)
  }

  const searchInputSetter = (value: string) => {
    setSearchInput(value)
  }

  const isNarrowSearchSetter = (value: boolean) => {
    setIsNarrowSearch(value)
  }

  return {
    loading,
    searchInput,
    debouncedSearchInput,
    isNarrowSearch,
    loadingSetter,
    searchInputSetter,
    isNarrowSearchSetter
  }
}
